export default "__VITE_ASSET__034e1460__"